<template>
    <div class="flex flex-col">

        <div>
            <div class="px-4">
                <input class="w-full" v-on:click="running = false" type="range" min="0" v-bind:max="times.length - 1"
                       v-model="index">
            </div>
        </div>

        <div class="flex mt-4 px-4">
            <div class="px-4">
                <button class="btn" v-on:click="running = !running">
                    <span v-show="!running"><i class="fa fa-play"></i></span>
                    <span v-show="running"><i class="fa fa-pause"></i></span>
                </button>
            </div>

            <div class="px-4">
                {{ active }}
            </div>
        </div>

    </div>
</template>

<script>
    export default {

        props: [
            'times'
        ],

        data() {
            return {
                index: 0,
                running: false,
                active: null,
            };
        },

        watch: {
            times(a1, a2) {
                if (a1.length === a2.length) {
                    return;
                }
                this.computeIndex();
            },
            active() {
                this.$emit('update', this.active);
            },
            index() {
                this.active = this.pop[this.index];
            }
        },

        computed: {
            pop: function () {
                // do not modify underlying array
                return this.times.slice().reverse();
            }
        },

        mounted() {
            let that = this;
            setInterval(function () {
                if (!that.running) {
                    return;
                }

                that.increase();
            }, 500);
        },

        created() {
            this.computeIndex()
        },

        methods: {
            computeIndex() {
                this.index = this.times.length - 1;
            },
            increase: function () {
                this.index++;
                if (this.index >= this.times.length) {
                    this.index = 0;
                    //this.running = false;
                }
            }
        }
    }
</script>